import React from "react";
import styles from "../../asset/Service/Artwork.module.scss";
import WhoWeAreImage from "../../asset/homefour/artwork/artwork1.webp";
import WhoWeAreImage2 from "../../asset/homefour/artwork/artwork2.webp";
import WhoWeAreImage3 from "../../asset/homefour/artwork/artwork3.webp";
import WhoWeAreImage4 from "../../asset/homefour/artwork/artwork4.webp";
import { Link } from "react-router-dom";



const Artwork = () => {
  const artworks = [
    {
      img: WhoWeAreImage,
      title: "Vector Conversions",
      link: "/portfolio/1",
    },
    {
      img: WhoWeAreImage2,
      title: "Image Edit",
      link: "/portfolio/5",
    },
    {
      img: WhoWeAreImage3,
      title: "Mockup",
      link: "/portfolio/7",
    },
    {
      img: WhoWeAreImage4,
      title: "Creative",
      link: "/portfolio/8",
    },
  ];

  return (
    <section className={styles.artworkSection}>
      <div className={styles.container}>
        <h2 className={styles.title}>Artwork</h2>
        <p className={styles.description}>
          Add perfection to your design workflow with our bespoke artwork services. Our design team transforms raw image inputs into camera-ready artwork for use by custom apparel decorators and the promotional products industry.
        </p>
        <p className={styles.description}>
          Camera-ready artwork is suitable for a variety of imprinting methods, including screen printing, engraving, laser etching, debossing/embossing, and enamel art. These techniques can be applied to a wide range of products such as apparel, promotional items, sportswear, headgear, and accessories.
        </p>
        <p className={styles.description}>
          Our artwork capabilities include vector design, redraws, name drops, image editing, custom rhinestone designs, virtual embroidery, and customer proofs, among many others.
        </p>

        <div className={styles.grid}>
          {artworks.map((item, index) => (
            <div key={index} className={styles.card}>
              <img src={item.img} alt={item.title} className={styles.image} />
              <div className={styles.cardContent}>
                <h3>{item.title}</h3>
                <Link to={item.link} className={styles.arrowBtn}>
                  →
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* <div className={styles.faqSection}>
          <p>
            Want to know more? Look up our FAQ page or speak to our responsive
            customer support team.
          </p>
          <button className={styles.faqBtn}>Let's get started</button>
        </div> */}
      </div>
    </section>
  );
};

export default Artwork;
